import { render, staticRenderFns } from "./LectureLearningTrackSubjectsWidget.vue?vue&type=template&id=ab66672c&scoped=true"
import script from "./LectureLearningTrackSubjectsWidget.vue?vue&type=script&lang=js"
export * from "./LectureLearningTrackSubjectsWidget.vue?vue&type=script&lang=js"
import style0 from "./LectureLearningTrackSubjectsWidget.vue?vue&type=style&index=0&id=ab66672c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab66672c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab66672c')) {
      api.createRecord('ab66672c', component.options)
    } else {
      api.reload('ab66672c', component.options)
    }
    module.hot.accept("./LectureLearningTrackSubjectsWidget.vue?vue&type=template&id=ab66672c&scoped=true", function () {
      api.rerender('ab66672c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/LectureLearningTrackSubjectsWidget.vue"
export default component.exports